import { Link, useLocation, useNavigate } from "react-router-dom";
import { House, FileText, Clock, UsersThree, Calculator, SignOut, User as UserIcon } from "@phosphor-icons/react";
import { useAuth } from "../lib/auth";
import { LogoMark } from "./Logo";

const navItems = [
  { to: "/dashboard", label: "Home", icon: House },
  { to: "/preventivi", label: "Preventivi", icon: FileText },
  { to: "/timbratura", label: "Ore", icon: Clock },
  { to: "/personale", label: "Personale", icon: UsersThree },
  { to: "/computo", label: "Computo", icon: Calculator },
];

export default function Layout({ children }) {
  const loc = useLocation();
  const nav = useNavigate();
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white pb-24">
      <header className="sticky top-0 z-30 bg-[#0A0A0A]/95 backdrop-blur border-b border-[#1A1A1A]">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/dashboard" className="flex items-center gap-2" data-testid="header-logo">
            <LogoMark size={32} />
            <span className="font-heading font-black text-2xl uppercase tracking-tight">ETA<span className="text-[#FFD600]">Build</span></span>
          </Link>
          <div className="flex items-center gap-3">
            {user?.is_admin && (
              <span data-testid="admin-badge" className="hidden sm:inline-flex text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded bg-[#FFD600] text-[#0A0A0A]">
                ADMIN
              </span>
            )}
            {!user?.is_admin && user?.subscription_status === "trial" && (
              <Link to="/abbonamento" data-testid="trial-badge"
                className="hidden sm:inline-flex text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded bg-[#FFD600]/10 text-[#FFD600] border border-[#FFD600]/30">
                Trial
              </Link>
            )}
            {!user?.is_admin && user?.subscription_status === "expired" && (
              <Link to="/abbonamento" data-testid="expired-badge"
                className="text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded bg-[#FF3B30]/10 text-[#FF3B30] border border-[#FF3B30]/30">
                Scaduto
              </Link>
            )}
            <button onClick={() => { logout(); nav("/login"); }} data-testid="logout-btn"
              className="p-2 rounded hover:bg-[#1A1A1A] text-[#A3A3A3] hover:text-white transition">
              <SignOut size={22} weight="bold" />
            </button>
            <Link to="/profilo" data-testid="header-profile"
              className="p-2 rounded hover:bg-[#1A1A1A] text-[#A3A3A3] hover:text-[#FFD600] transition">
              <UserIcon size={22} weight="bold" />
            </Link>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-6">{children}</main>

      <nav className="fixed bottom-0 inset-x-0 bg-[#0A0A0A] border-t border-[#1A1A1A] z-30">
        <div className="max-w-3xl mx-auto px-2 py-2 grid grid-cols-5 gap-1">
          {navItems.map((it) => {
            const active = loc.pathname.startsWith(it.to);
            const Icon = it.icon;
            return (
              <Link key={it.to} to={it.to} data-testid={`nav-${it.label.toLowerCase()}`}
                className={`flex flex-col items-center justify-center py-2 rounded-md transition ${active ? "bg-[#FFD600]/10 text-[#FFD600]" : "text-[#A3A3A3] hover:text-white"}`}>
                <Icon size={26} weight={active ? "fill" : "bold"} />
                <span className="text-[10px] font-bold uppercase tracking-wider mt-0.5">{it.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
